import { NavLink, useLocation, useParams } from "react-router-dom";

export default function CustomerTabsJobFile({ job, className = "" }) {
  const { contractNo, id } = useParams();
  const location = useLocation();
  // ใช้ contractNo ถ้ามี (จาก route /jobfile/:contractNo) หรือ id (จาก route /jobfile/:id/...)
  const jobId = contractNo || id;
  const navState = location.state || {};

  return (
    <div className={`border-b border-gray-200 bg-white px-6 py-4 ${className}`}>
      <h2 className="text-xl font-bold text-gray-800 mb-3">
        {job?.Contract_No || "CT-XXXXXX"}
      </h2>

      <nav className="flex gap-10 text-sm font-medium">

        {/* ข้อมูลลูกค้า */}
        <NavLink
          to={`/jobfile/${jobId}`}
          state={navState}
          end   // ⭐ บังคับให้ match เฉพาะ path นี้เท่านั้น!
          className={({ isActive }) =>
            `pb-2 transition ${
              isActive
                ? "border-b-2 border-red-500 text-black font-bold"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          ข้อมูลลูกค้า
        </NavLink>

        {/* จ็อบงาน */}
        <NavLink
          to={`/jobfile/${jobId}/jobs`}
          state={navState}
          className={({ isActive }) =>
            `pb-2 transition ${
              isActive
                ? "border-b-2 border-red-500 text-black font-bold"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          จ็อบงาน
        </NavLink>

      </nav>
    </div>
  );
}
